import Swiper from 'swiper/bundle';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import EffectCardsStack from './effect-cards-stack.esm.js';
// effect-cards-stack 플러그인을 쓰면 여기서 import 유지

const markInited = (el) => {
  if (el.dataset.swiperInited === '1') return false;
  el.dataset.swiperInited = '1';
  return true;
};

const resolveControls = (container) => ({
  nextEl: container.querySelector('.swiper-button-next'),
  prevEl: container.querySelector('.swiper-button-prev'),
  paginationEl: container.querySelector('.swiper-pagination'),
});

const initDefaultSwipers = () => {
  document
    .querySelectorAll('[data-component="swiper-default"]')
    .forEach((container) => {
      if (!markInited(container)) return;

      const { nextEl, prevEl, paginationEl } = resolveControls(container);
      const hasNav = !!(nextEl && prevEl);
      const hasPag = !!paginationEl;

      new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination],
        slidesPerView: 1.1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: false,
        autoplay:
          container.dataset.autoplay === 'true' ? { delay: 3000 } : false,

        // ✅ 항상 객체로 넘기고 enabled로 제어
        navigation: {
          enabled: hasNav,
          nextEl: hasNav ? nextEl : undefined,
          prevEl: hasNav ? prevEl : undefined,
        },
        pagination: {
          enabled: hasPag,
          el: hasPag ? paginationEl : undefined,
          clickable: true,
        },

        breakpoints: {
          640: { slidesPerView: 1.4 },
          768: { slidesPerView: 2.2, centeredSlides: false },
          1024: { slidesPerView: 3, centeredSlides: false },
        },
        observer: true,
        observeParents: true,
      });
    });
};

const initCardsSwipers = () => {
  document
    .querySelectorAll('[data-component="swiper-cards"]')
    .forEach((container) => {
      if (!markInited(container)) return;

      new Swiper(container, {
        loop: true,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        loopAdditionalSlides: 2,
        centeredSlides: true,
        direction: 'vertical',
        modules: [Autoplay, EffectCardsStack],
        effect: 'cards-stack',
        grabCursor: true,
        touchRatio: 1.5,
        speed: 800,
        observer: true,
        observeParents: true,
      });
    });
};

const InitSwiper = () => {
  window.addEventListener('load', () => {
    initDefaultSwipers();
    initCardsSwipers();
  });
};

export default InitSwiper;
